export default __webpack_public_path__ + "static/2262-8b661f1eff609fd2494198cfa67e8545.gif";